import type { Content } from "@/partner/entities/contents";
import type { VideoFormValues } from "./types";

export const mapVideoToFormValues = (content: Content): VideoFormValues => ({
  title: content.title || "",
  description: content.description ?? null,
  tagIds: content.tags?.map((t) => t.id) ?? [],
  previewId: content.preview?.id ?? null,
  verticalPreviewId: content.verticalPreview?.id ?? null,
  publishAt: content.publishAt ?? null,
  accessStartAt: content.accessStartAt ?? null,
  hideInGeneralLists: content.hideInGeneralLists ?? false,
  onlyUsers: content.onlyUsers ?? false,
  ageRestrictions: content.ageRestrictions ?? 0,
  // videoUid здесь используется только для «есть файл?»-логики формы
  // (VideoUploadField), поэтому берём id текущего/обрабатываемого видео —
  // само значение поля видео показывает имя файла (см. VideoUploadField).
  videoUid: content.pendingVideo?.uid ?? content.video?.uid ?? null,
  videoFileName:
    content.pendingVideo?.fileName ?? content.video?.fileName ?? null,
  countryAccessId: content.countryAccess?.id ?? null,
  widgetId: content.widget?.id ?? null,
  collectionIds: content.collectionIds ?? [],
  productIds: content.productIds ?? [],
  // Флаг живёт на Video: у контента с ещё не дозагруженным файлом он
  // читается из pendingVideo (updateContent пишет его во все видео
  // контента, см. VideoService.syncChatEnabled).
  isChatEnabled:
    content.video?.isChatEnabled ??
    content.pendingVideo?.isChatEnabled ??
    false,
});
